
export const loading="loading"
export const error="error"
export const Get_Todo="get/todo"
export const Add_Todo="add/todo"
export const Update_Todo="update/todo"
export const Delete_Todo="delete/todo"
